/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Weekdays_InvalidInputs */

const vi_error_irrigation_schedule_weekdays_invalid = /** @type {(inputs: Error_Irrigation_Schedule_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày áp dụng không hợp lệ, vui lòng chọn lại`)
};

/**

* @param {Error_Irrigation_Schedule_Weekdays_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_weekdays_invalid = /** @type {((inputs?: Error_Irrigation_Schedule_Weekdays_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Weekdays_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_weekdays_invalid(inputs)
});